<template>
  <div class="product-list-paging-wrapper">
    <div
      v-if="showPageUpButton"
      class="product-list-paging-wrapper__button product-list-paging-wrapper__button--top | button"
      :class="{'button--loading': isLoading}"
      @click="setPage(getPrevPageNum(), 'prepend')"
    >
      {{ $t('product_list.paging.load_more') }}
    </div>
    <slot />
    <div
      v-if="showPageDownButton"
      class="product-list-paging-wrapper__button product-list-paging-wrapper__button--bottom | button"
      :class="{'button--loading': isLoading}"
      @click="setPage(getNextPageNum(), 'append')"
    >
      {{ $t('product_list.paging.load_more') }}
    </div>
  </div>
</template>

<script lang="ts">
  import {Vue, Options, Prop} from 'vue-property-decorator';
  import productListStore, {ProductListStore} from '../../stores/product/ProductListStore';
  import productListService, {ListElementPlacementMode, ProductsListService} from '../../services/productsList/ProductsListService';
  import {intersectionService} from '../../utilities/js/intersectionService/intersectionService';
  import * as scrollToElement from 'scroll-to-element';
  import pigeon from '../../utilities/js/pigeon/pigeon';

  @Options({
    name: 'product-list-paging-wrapper',
  })
  export default class productListPagingWrapper extends Vue {
    @Prop({default: 0})
    offsetTop: number;

    productListStore: ProductListStore = productListStore;
    isLoading = false;

    created() {
      pigeon.subscribe('productList:loadStart', () => {
        this.isLoading = true;
      });
      pigeon.subscribe('productList:loadComplete', () => {
        this.isLoading = false;
      });

      this.productListStore.addLoadedPage(this.productListStore.pagingData.currentPage);

      if (this.productListStore.pagingData.currentPage === 1) {
        this.productListStore.clearCache();
      } else {
        this.productListStore.restoreFromCache();
      }
    }

    getPrevPageNum() {
      return this.productListStore.loadedPages[0] - 1;
    }

    getNextPageNum() {
      return this.productListStore.loadedPages[this.productListStore.loadedPages.length -1] + 1;
    }

    get showPageUpButton() {
      return !this.productListStore.loadedPages.includes(1);
    }

    get showPageDownButton() {
      return this.productListStore.pagingData.currentPage < this.productListStore.pagingData.pagesCount;
    }

    setPage(page: number, productReplacement: ListElementPlacementMode) {
      if (this.isLoading) {
        return
      }

      const param = {};
      param[ProductsListService.pageParameterName] = [page - 1];
      const firstElementOfList = document.querySelector('.products-list__element');

      if (productReplacement === 'prepend') {
        intersectionService.disable();
      }

      productListService.changeParameters(param, {elementPlacement: productReplacement})
        .then(() => {
          this.productListStore.addLoadedPage(page);
          this.productListStore.saveToCache();

          if (productReplacement === 'prepend') {
            const tween = scrollToElement(firstElementOfList, {duration: 0, offset: -80});
            tween.on('end', () => {
              setTimeout(() => {
                intersectionService.enable();
                intersectionService.activateAll('lazyload');
              }, 800);
            });
          }
        });
    }
  }
</script>
